import sprite from '../../../assets/images/google_map_markers.png';
const gApi = (window as any).google

function markerImage(x, y, w, h) {
  return new gApi.maps.MarkerImage(sprite, new gApi.maps.Size(w, h), new gApi.maps.Point(x, y))
}

const PropertyMarkers = {
  villas: markerImage(6, 7, 36, 54),
  apartments: markerImage(49, 7, 35, 53),
  hotels: markerImage(92, 7, 35, 53),
  "ski-chalets": markerImage(136, 7, 34, 52),
  yachts: markerImage(179, 7, 35, 53),
  camps: markerImage(49, 131, 36, 54),
  lodges: markerImage(92, 131, 35, 53),
  castles: markerImage(135, 131, 36, 54),
  "private-islands": markerImage(178, 131, 36, 54),
  trains: markerImage(221, 131, 36, 54),
  "house-boats": markerImage(264, 131, 36, 54)
}

export function propertyMarker(type: string) {
  if (PropertyMarkers[type] !== undefined) return PropertyMarkers[type]
  else return PropertyMarkers.villas
}

const PropertyHighlightedMarkers = {
  villas: markerImage(6, 71, 36, 54),
  apartments: markerImage(49, 71, 35, 53),
  hotels: markerImage(92, 71, 35, 53),
  "ski-chalets": markerImage(136, 71, 34, 52),
  yachts: markerImage(179, 71, 35, 53),
  camps: markerImage(49, 195, 36, 54),
  lodges: markerImage(92, 196, 35, 53),
  castles: markerImage(135, 196, 36, 54),
  "private-islands": markerImage(178, 196, 36, 54),
  trains: markerImage(221, 196, 36, 54),
  "house-boats": markerImage(264, 196, 36, 54)
}

export function propertyHighlightedMarker(type: string) {
  if (PropertyHighlightedMarkers[type] !== undefined) return PropertyHighlightedMarkers[type]
  else return PropertyHighlightedMarkers.villas
}

const AncillaryMarkers = {
  restaurant: markerImage(259, 7, 30, 44),
  cultural: markerImage(306, 7, 28, 43),
  experience: markerImage(352, 7, 30, 44),
  activity: markerImage(400, 7, 28, 43),
  "guided-tour": markerImage(446, 7, 29, 43),
  zen: markerImage(493, 7, 30, 44),
  wine: markerImage(539, 6, 29, 43),
  golf: markerImage(587, 6, 30, 44),
  "water-sports": markerImage(633, 6, 29, 43),
  equestrian: markerImage(680, 6, 29, 43),
  shopping: markerImage(725, 7, 29, 43),
  cafe: markerImage(769, 7, 29, 43),
  bar: markerImage(813, 7, 29, 43)
}

export function ancillaryMarker(type: string) {
  if (AncillaryMarkers[type] !== undefined) return AncillaryMarkers[type]
  else return AncillaryMarkers.experience
}

const AncillaryHighlightedMarkers = {
  restaurant: markerImage(259, 77, 30, 44),
  cultural: markerImage(306, 77, 28, 43),
  experience: markerImage(352, 77, 30, 44),
  activity: markerImage(400, 78, 28, 43),
  "guided-tour": markerImage(446, 77, 29, 43),
  zen: markerImage(493, 77, 30, 44),
  wine: markerImage(539, 76, 29, 43),
  golf: markerImage(587, 76, 30, 44),
  "water-sports": markerImage(633, 76, 29, 43),
  equestrian: markerImage(680, 76, 29, 43),
  shopping: markerImage(725, 76, 29, 43),
  cafe: markerImage(769, 76, 29, 43),
  bar: markerImage(813, 76, 29, 43)
}

export function ancillaryHighlightedMarker(type: string) {
  if (AncillaryHighlightedMarkers[type] !== undefined) return AncillaryHighlightedMarkers[type]
  else return AncillaryHighlightedMarkers.experience
}

export function templateMarker() {
  return markerImage(6, 131, 36, 54)
}